import { render, staticRenderFns } from "./PaymentAdjustment.vue?vue&type=template&id=061bac4a"
import script from "./PaymentAdjustment.vue?vue&type=script&lang=js"
export * from "./PaymentAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports